import React, { useState } from "react";
import "./style.scss";
import searchIcon from "../../assets/icons/search.svg";
import bellIcon from "../../assets/icons/bell.svg";
import { Link, useLocation } from "react-router-dom";
import menuData from "../../Layout/MenuData";
import crossIcon from "../../assets/icons/cross.svg";
import Logo from "../../assets/icons/acg-logo.png";
import Logout from "../../assets/icons/logout.svg";
import { deAuthenticateAll } from "../../utils/store/reducers/Index";
import { clearPersistedData } from "../../utils/store/store";
import { useDispatch } from "react-redux";
import { isActive } from "../Sidebar";
import Breadcrumbs from "../Breadcrumb/Breadcrumb";
function Header({ headerName }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const dispatch = useDispatch();
  const handleLogout = () => {
    deAuthenticateAll(dispatch);
    clearPersistedData();
  };

  return (
    <>
      <div className="header-wrapper">
        <div className="header">
          <div className="header-left">
            {/* <h2>{headerName}</h2> */}
            <Breadcrumbs headerName={headerName}  />
          </div>

          <div className="header-right">
            {/* <img src={searchIcon} alt="" />
            <img src={bellIcon} alt="" /> */}
            {location.pathname === "/" && (
              <button className="standard-button leaderboard-btn-mobile-visible">
                {" "}
                <Link to="/competition/26">See Leaderboard</Link>
              </button>
            )}
            <button className="standard-button">
              {" "}
              <Link to="/Assessments">Start New Challenge</Link>
            </button>
          </div>
          <div className="mobile-menu-icon">
            <svg
              onClick={toggleMobileMenu}
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.9998 2.66699C14.2489 2.66699 12.5151 3.01187 10.8974 3.68193C9.27972 4.35199 7.80986 5.33412 6.57175 6.57223C4.07126 9.07272 2.6665 12.4641 2.6665 16.0003C2.6665 19.5365 4.07126 22.9279 6.57175 25.4284C7.80986 26.6665 9.27972 27.6487 10.8974 28.3187C12.5151 28.9888 14.2489 29.3337 15.9998 29.3337C19.5361 29.3337 22.9274 27.9289 25.4279 25.4284C27.9284 22.9279 29.3332 19.5365 29.3332 16.0003C29.3332 14.2494 28.9883 12.5156 28.3182 10.8979C27.6482 9.2802 26.666 7.81035 25.4279 6.57223C24.1898 5.33412 22.72 4.35199 21.1023 3.68193C19.4846 3.01187 17.7508 2.66699 15.9998 2.66699ZM7.99984 9.33366H23.9998V12.0003H7.99984V9.33366ZM7.99984 14.667H23.9998V17.3337H7.99984V14.667ZM7.99984 20.0003H23.9998V22.667H7.99984V20.0003Z"
                fill="#4BB390"
              />
            </svg>
          </div>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-header">
            <img
              src={Logo}
              alt="company_logo"
              className="company_logo_mobile"
            />
            <img
              src={crossIcon}
              alt=""
              onClick={toggleMobileMenu}
              className="cross_icon_mobile"
            />
          </div>

          <div className="mobile-menu-items">
            {menuData.map((menuItem, index) => (
              <Link
                key={index}
                to={menuItem.path}
                className="mobile-menu-link"
                onClick={toggleMobileMenu}
              >
                <div
                  className={`mobile-menu-item ${
                    isActive(menuItem, location) ? "active" : ""
                  }`}
                  // className={`mobile-menu-item ${
                  //   location.pathname === menuItem.path ? "active" : ""
                  // }`}
                >
                  {menuItem.icon}
                  <span>{menuItem.title}</span>
                </div>
              </Link>
            ))}
            <div className="logout_container" onClick={handleLogout}>
              <img
                className="logout"
                src={Logout}
                alt="Logout Icon"
                style={{ cursor: "pointer", width: "14px", height: "14px" }}
              />
              <p>Logout</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
